import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
} from "react";
import classNames from "classnames";
import DropDown from "../../utils/components/common/dropdown/dropdown";
import Pagination from "../../utils/components/common/pagination";
import Modal from "../../utils/components/common/modal";
import Icons from "../../utils/components/icons";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";
import { UserContext, OrganisationContext } from "../../layouts/MainLayout";
import EmptyScreen from "../../utils/components/common/EmptyScreen/EmptyScreen";
import {
  USER_ROLES,
  USER_ROLES_STR,
} from "../../utils/constants/userConstants";
import {
  updateUser,
  sendUserInvite,
  getUsersForTenant,
  deleteDisableUserByCognitoId,
} from "../../services/UserService";
import EditUser from "./EditUser";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";

import "./userList.scss";
import "./addUser.scss";
import { useRef } from "react";
import { useIsMount } from "../../utils/components/common/useIsMount";

const UserList = () => {
  const { userData, userCognitoData, loggedInUserRole } =
    useContext(UserContext);
  const { orgData, siteData } = useContext(OrganisationContext);

  const { t } = useTranslation("usermanagement");

  const [columList, setColumList] = useState([
    {
      key: "email",
      label: t("table.email"),
      val: "asc",
      clickCount: 1,
      sort: true,
    },
    { key: "name", label: t("table.name"), val: "", clickCount: 0, sort: true },
    {
      key: "phone",
      label: t("table.phone"),
      val: "",
      clickCount: 0,
      sort: false,
    },
    { key: "role", label: t("table.role"), val: "", clickCount: 0, sort: true },
    {
      key: "action",
      label: t("table.action"),
      val: "",
      clickCount: 0,
      sort: false,
    },
  ]);
  const sortLabel = {
    asc: "Ascending sort",
    desc: "Descending sort",
    "": "No sort",
  };

  const [pageTotalCount, setPageTotalCount] = useState(0);
  const [editingRow, setEditingRow] = useState(null);
  const [userDataList, setUserDataList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [disableInput, setDisableInput] = useState(false);
  const queryCount = 10;

  const rolesForAdmin = [
    { label: t("roles.viewOnlyUser"), value: "View Only User" },
    { label: t("roles.user"), value: "User" }
  ];

  const rolesForSuperAdmin = [
    { label: t("roles.viewOnlyUser"), value: "View Only User" },
    { label: t("roles.user"), value: "User" },
    { label: t("roles.admin"), value: "Admin" },
    {
      label: t("roles.superAdmin"),
      value: "Super Admin",
    }
  ];

  const userSiteLists = useMemo(() => {
    return orgData?.SiteList;
  }, [orgData]);

  /**Add User States Starts */
  const [roleSelected, setRoleSelected] = useState("View Only User");
  const [inviteSuccess, setInviteSuccess] = useState(null);
  const [acceptModal, setAcceptModal] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [isEmailSubmit, setIsEmailSubmit] = useState(false);
  const [isModalTrue, setIsModalTrue] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [emailInput, setEmailInput] = useState("");
  const [emails, setEmails] = useState([]);
  const [finalCheckedList, setFinalCheckedList] = useState([]);

  /**Add User States Ends */

  /**Edit User States Starts */
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [saveEditSuccessModal, setSaveEditSuccessModal] = useState(false);
  const [saveEditFailureModal, setSaveEditFailureModal] = useState(false);
  const [enableErrorModal, setEnableErrorModal] = useState(false);
  const [disableErrorModal, setDisableErrorModal] = useState(false);
  const [deleteErrorModal, setDeleteErrorModal] = useState(false);
  const [deletedSuccessfully, setDeletedSuccessfully] = useState(false);

  /**Edit User States Ends */

  const [displayedUSers, setDisplayedUSers] = useState([]);
  const [showUsers, setShowUsers] = useState(false);
  const [totalUserCount, setTotalUserCount] = useState(0);
  const [filteredUserCount, setFilteredUserCount] = useState(0);

  
  /**Session Storage functionality Starts */
  
  const [selectedRole, setSelectedRole] = useState(
    sessionStorage.getItem("userDashboardDetails")
      ? JSON.parse(sessionStorage.getItem("userDashboardDetails")).selectedRole
      : "All"
  );

  const [searchTerm, setSearchTerm] = useState(
    sessionStorage.getItem("userDashboardDetails")
      ? JSON.parse(sessionStorage.getItem("userDashboardDetails")).searchTerm
      : ""
  );

  const [searchString, setSearchString] = useState(
    sessionStorage.getItem("userDashboardDetails")
      ? JSON.parse(sessionStorage.getItem("userDashboardDetails")).searchString
      : ""
  );

  const [pageCount, setPageCount] = useState(
    sessionStorage.getItem("userDashboardDetails")
      ? JSON.parse(sessionStorage.getItem("userDashboardDetails")).pageNo
      : 1
  );
  
  const [userDashboardDetails, setUserDashboardDetails] = useState({
    selectedRole: selectedRole,
    searchString: searchString,
    searchTerm: searchTerm,
    pageNo: pageCount
  });

  const storeSessionData = useCallback((search, role, searchTerm, page) => {
    if (search) {
      setUserDashboardDetails((prevState) => ({
        ...prevState,
        searchString: search,
      }));
    }

    if (role) {
      setUserDashboardDetails((prev) => ({
        ...prev,
        selectedRole: role,
      }));
    }

    if (searchTerm) {
      setUserDashboardDetails((prev) => ({
        ...prev,
        searchTerm: searchTerm,
      }));
    }

      if (page) {  
        setUserDashboardDetails((prev) => ({
          ...prev,
          pageNo: page,
        }));
      }
  }, []);
  
  useEffect(() => {
    sessionStorage.setItem(
      "userDashboardDetails",
      JSON.stringify(userDashboardDetails)
    );
  }, [userDashboardDetails]);

  /**Session Storage functionality Ends */

  /**Search functionality Starts */

  const debounceTime = 2000;
  const timeoutCall = useRef(null);

  const debounceCallBack = useCallback((callBackFunc) => {
    if (timeoutCall.current !== null) {
      clearTimeout(timeoutCall.current);
    }
    timeoutCall.current = setTimeout(() => {
      callBackFunc();
    }, debounceTime);
  }, []);

  const resetSearch = useCallback(() => {
    setSearchTerm("");
    setPageCount(1);
    setSearchString("");

    const userObject = JSON.parse(
      sessionStorage.getItem("userDashboardDetails")
    );

    if (userObject && userObject.selectedRole) {
      delete userObject.searchString;
      delete userObject.searchTerm;

      sessionStorage.setItem(
        "userDashboardDetails",
        JSON.stringify(userObject)
      );
    }
  }, []);

  const handleSearchChange = useCallback(
    (e) => {
      setSearchTerm(e.target.value);
      storeSessionData("", "", e.target.value);
      debounceCallBack(() => {
        setPageCount(1);
        setSearchString(e.target.value);
        storeSessionData(e.target.value,"","",1);
      });
    },
    [debounceCallBack, storeSessionData]
  );

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter") {
        debounceCallBack(() => {
          setPageCount(1);
          setSearchString(event.target.value);
          storeSessionData(event.target.value,"","",1);
        });
      }
    },
    [debounceCallBack, storeSessionData]
  );
  /**Search functionality Ends */

  /**UserList Logic Starts */
  
  const isFirstMount = useIsMount();
  
  const prevRoleRef = useRef();
  useEffect(() => {

    if (isFirstMount) return;

    if (prevRoleRef.current !== selectedRole) {
      setPageCount(1); // Reset to the first page if the role has changed
      storeSessionData("","","", 1);
      prevRoleRef.current = selectedRole;
    }
  }, [selectedRole, storeSessionData]);

  const fetchData = useCallback(
    async (role) => {
      if (
        !(
          Object.keys(userCognitoData).length &&
          Object.keys(userData).length &&
          Object.keys(orgData).length
        )
      )
        return;
      const queryParams = {
        tenantId: userData?.OrganizationID,
        requestedByUserId:
          userCognitoData?.signInUserSession?.accessToken?.payload?.username,
        size: 10,
        pageNo: pageCount,
        filters: {
          userRole: role,
        },
        sort: [],
      };
      if (columList.find((v) => v.key === "email").val) {
        queryParams.sort.push({
          email: columList.find((v) => v.key === "email").val,
        });
      }
      if (columList.find((v) => v.key === "name").val) {
        queryParams.sort.push({
          userName: columList.find((v) => v.key === "name").val,
        });
      }
      if (columList.find((v) => v.key === "role").val) {
        queryParams.sort.push({
          userRole: columList.find((v) => v.key === "role").val,
        });
      }

      if (role === "All") {
        queryParams.filters = "";
      }

      if (userData.UserRole !== "Super Admin") {
        queryParams.siteId = siteData.id;
      }

      if (searchString?.length > 0) {
        queryParams.search = searchString;
      }

      getUsersForTenant(queryParams)
        .then((response) => {
          setUserDataList(response.data.Items);
          setTotalUserCount(response?.data?.OverallUsersCount);
          setFilteredUserCount(response?.data?.TotalUserCount);

          setPageTotalCount(
            Math.ceil(response.data.TotalUserCount / queryCount)
          );
          setDisplayedUSers(response.data.Items);
          setShowUsers(true);
          setIsLoading(false);
        })
        .catch((error) => {
          setShowUsers(true);
          setIsLoading(false);
        });
    },
    [
      orgData,
      pageCount,
      searchString,
      siteData.id,
      userCognitoData,
      userData,
      columList,
    ]
  );

  useEffect(() => {
    setIsLoading(true);
    fetchData(selectedRole);
  }, [
    pageCount,
    userData,
    orgData,
    userCognitoData,
    selectedRole,
    siteData,
    fetchData,
  ]);

  const handlePageChange = useCallback((item) => {
    setPageCount(item + 1);
    storeSessionData("","","", item + 1);
  }, [storeSessionData]);

  const handleSort = (key) => {
    let sortColumnIndex = columList.findIndex((item) => item.key === key);
    let listCopy = [...columList];

    if (listCopy[sortColumnIndex].clickCount === 2) {
      listCopy[sortColumnIndex].clickCount = 0;
      listCopy[sortColumnIndex].val = "";
    } else {
      listCopy[sortColumnIndex].clickCount =
        listCopy[sortColumnIndex].clickCount + 1;
      listCopy[sortColumnIndex].val =
        listCopy[sortColumnIndex].clickCount === 1 ? "asc" : "desc";
    }
    setColumList(listCopy);
  };
  /**Sort functionality Ends */
  /**UserList Logic Ends */

  /**Add User Functions Starts */
  const handleAddUser = () => {
    setIsModalTrue(true);
  };

  const sendInvite = useCallback(async () => {
    const queryParam = {
      emailId: emails,
      role: roleSelected,
      site: finalCheckedList,
      initiatedUser: userData.PK.slice(2),
      tenantID: userData.OrganizationID,
      initiatedBy: userData.UserName,
    };
    sendUserInvite(queryParam)
      .then((response) => {
        if (response) {
          setInviteSuccess(true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (error.response.status !== 400) {
          setErrorMessage(
            "The App could not create New User invite. Please try again after some time."
          );
          setInviteSuccess(false);
          setIsLoading(false);
        } else {
          const errorObj = error.response.data;
          // const errorObj = JSON.parse(error.response.data.substring(7));
          const emails = errorObj?.Emails;
          const message = errorObj.Message;

          if (message === "Emails already available.") {
            setErrorMessage(
              `The following Email IDs are already registered with Chorus - ${emails}`
            );
            setIsButtonValid(false);
            setInviteSuccess(false);
            setIsLoading(false);
          } else {
            setErrorMessage(
              " The App could not create New User invite. Please try again after some time."
            );
            setInviteSuccess(false);
            setIsLoading(false);
          }
        }
      });
  }, [
    emails,
    roleSelected,
    userData.OrganizationID,
    userData.PK,
    userData.UserName,
    finalCheckedList,
  ]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setCheckedList([...checkedList, value]);
    } else {
      setCheckedList(checkedList.filter((item) => item !== value));
    }
    setFinalCheckedList([...checkedList, value]);
  };

  const handleModalClose = () => {
    setAcceptModal(false);
    setCancelModal(false);
    setIsModalTrue(false);
    handleInviteCancel();
  };

  const handleFailureModalClose = () => {
    setAcceptModal(false);
  };
  const addEmails = () => {
    const newEmails = emailInput.split(",").map((email) => email.trim());

    if (newEmails[newEmails.length - 1].trim() === "") {
      newEmails.pop();
    }
    let errorFlag = false;
    for (let i = 0; i < newEmails.length; i++) {
      const email = newEmails[i];
      if (emails.length + i >= 5) {
        setError("Please enter upto 5 emails");
        errorFlag = true;
        break;
      }
      if (isInvalid(email)) {
        setError("Invalid email address");
        errorFlag = true;
        break;
      }
    }
    if (!errorFlag) {
      setEmails([...emails, ...newEmails]);
      setEmailInput("");
      setDisableInput(emails.length + newEmails.length === 5);
    }
  };

  const handleEmailInputKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();

      const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]\.[0-9]\.[0-9]\.[0-9]\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/;

      const maxLengthUsername = 64;
      const maxLengthDomain = 255;
      const invalidCharactersRegex = /[#$%^&*()?\{\}`=\#!|+~]/;

      const emailAddresses = emailInput.split(",").map((email) => email.trim());

      if (emailAddresses.length > 5) {
        setError("Maximum 5 email addresses are allowed");
        return;
      }

      for (const emailAddress of emailAddresses) {
        if (!emailRegex.test(emailAddress)) {
          setError("Invalid email address");
          return;
        }

        if (emailAddress.length > maxLengthUsername + maxLengthDomain + 1) {
          setError("Invalid email address");
          return;
        }

        if (invalidCharactersRegex.test(emailAddress)) {
          setError("Invalid email address");
          return;
        }
      }

      setError(false);
      setIsEmailSubmit(true);
      setTimeout(() => {
        addEmails();
      }, 0);
    }
  };

  const handleEmailAddition = (event) => {
    event.preventDefault();

    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]\.[0-9]\.[0-9]\.[0-9]\])|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}))$/;

    const maxLengthUsername = 64;
    const maxLengthDomain = 255;
    const invalidCharactersRegex = /[#$%^&*()?\{\}`=\#!|+~]/;

    // Split the emailInput by commas to get individual email addresses
    const emailAddresses = emailInput.split(",").map((email) => email.trim());

    // Check the number of email addresses
    if (emailAddresses.length > 5) {
      setError("Maximum 5 email addresses are allowed");
      return;
    }

    if (emailAddresses.length === 1) {
      if (emailAddresses[0] === "") {
        setError("");
        return;
      }
    }

    // Check each email address separately
    for (const emailAddress of emailAddresses) {
      if (!emailRegex.test(emailAddress)) {
        setError("Invalid email address");
        return;
      }

      if (emailAddress.length > maxLengthUsername + maxLengthDomain + 1) {
        setError("Invalid email address");
        return;
      }

      if (invalidCharactersRegex.test(emailAddress)) {
        setError("Invalid email address");
        return;
      }
    }

    addEmails();
    setError(false);
    setIsEmailSubmit(true);
    setEmailInput("");
  };

  const removeEmail = (index) => {
    setEmails([...emails.slice(0, index), ...emails.slice(index + 1)]);
    setDisableInput(false);
    setError(false);
    setIsEmailSubmit(false);
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    const invalid = isInvalid(newValue);
    setError(invalid ? "Invalid email address" : false);
    setEmailInput(newValue);
  };

  const isInvalid = (value) => {
    const wordCount = value.split(",").length;
    if (wordCount > 1) {
      if (typeof value === "string") {
        const words = value.split(", ");

        words.map((individualWords) => {
          const emailParts = individualWords.split("@");
          if (emailParts.length !== 2) return true;
          const [username, domain] = emailParts;
          if (username.length > 64) return true;
          if (domain.length > 255) return true;
          const domainParts = domain?.split(".");
          if (!domainParts || domainParts.length < 2) return true;
          const extension = domainParts[domainParts.length - 1];

          return extension.length < 2 || extension.length > 6 ? true : false;
        });
      }
    } else {
      const emailParts = value.split("@");
      if (emailParts.length !== 2) return true;
      const [username, domain] = emailParts;
      if (username.length > 64) return true;
      if (domain.length > 255) return true;
      const domainParts = domain?.split(".");
      if (!domainParts || domainParts.length < 2) return true;
      const extension = domainParts[domainParts.length - 1];

      return extension.length < 2 || extension.length > 6 ? true : false;
    }
  };

  useEffect(() => {
    if (emails.length > 0) {
      if (checkedList.length === 0) {
        setIsButtonValid(false);
      } else {
        if (checkedList.length !== 0 && finalCheckedList.length !== 0) {
          setIsButtonValid(true);
        }
      }
    }

    if (emails.length > 0) {
      setIsEmailSubmit(true);
    }

    if (roleSelected && roleSelected === "Super Admin") {
      if (emails.length > 0) {
        setIsButtonValid(true);
      }
    }
  }, [roleSelected, emails, finalCheckedList, checkedList]);

  const handleInviteCancel = () => {
    setFinalCheckedList([]);
    setCheckedList([]);
    setEmails([]);
    setEmailInput("");
    setRoleSelected("View Only User");
    setIsButtonValid(false);
    setError("");
    setDisableInput(false);
  };
  /**Add User Functions Ends */

  /**New Implementation of edit user modal starts */

  const handleEditUser = (currentUserRole, currentUserSites) => {
    setIsEditModalOpen(false);
    setIsLoading(true);
    const queryParam = {
      userId: editingRow?.PK?.slice(2),
      requestedByUserId:
        userCognitoData?.signInUserSession?.accessToken?.payload?.username,
      roleName: currentUserRole,
      siteList: currentUserSites,
      tenantId: userData?.OrganizationID,
    };
    updateUser(queryParam)
      .then((response) => {
        fetchData(selectedRole);
        setIsLoading(false);
        setSaveEditSuccessModal(true);
      })
      .catch((error) => {
        setIsLoading(false);
        setSaveEditFailureModal(true);
      });
  };

  const onEditUserclick = useCallback((selectedUserRow) => {
    setIsEditModalOpen(true);
    setEditingRow(selectedUserRow);
  }, []);

  const handleDisableConfirmation = (user, action) => {
    setIsEditModalOpen(false);
    setIsLoading(true);
    const queryParams = {
      userID:
        userCognitoData?.signInUserSession?.accessToken?.payload?.username,
      action: "disable",
      modifiedUserID: editingRow?.PK?.slice(2),
    };

    deleteDisableUserByCognitoId(queryParams)
      .then((response) => {
        setUserDataList((prevData) =>
          prevData.map((item) =>
            item.Email === user.Email
              ? { ...item, AccountStatus: "Disabled" }
              : { ...item }
          )
        );
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setDisableErrorModal(true);
      });
  };

  const handleEnableConfirmation = (user) => {
    setIsLoading(true);
    const queryParams = {
      userID:
        userCognitoData?.signInUserSession?.accessToken?.payload?.username,
      action: "enable",
      modifiedUserID: editingRow?.PK?.slice(2),
    };
    deleteDisableUserByCognitoId(queryParams)
      .then((response) => {
        if (response) {
          const updatedUsers = displayedUSers;
          const disableUserRow = updatedUsers.map((row) =>
            row.Email === editingRow.Email
              ? { ...row, AccountStatus: "Enabled" }
              : { ...row }
          );
          setUserDataList(disableUserRow);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setEnableErrorModal(true);
      });
  };

  const handleDeleteConfirmation = (row) => {
    setIsLoading(true);

    const queryParams = {
      userID:
        userCognitoData?.signInUserSession?.accessToken?.payload?.username,
      action: "delete",
      modifiedUserID: editingRow?.PK?.slice(2),
    };

    deleteDisableUserByCognitoId(queryParams)
      .then((response) => {
        if (response.data.msg === null) {
          setDeleteErrorModal(true);
          setIsLoading(false);
        } else {
          setUserDataList((prevData) =>
            prevData.filter((itm) => itm.Email !== row.Email)
          );
          setDeletedSuccessfully(true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setDeleteErrorModal(true)
        setIsLoading(false);
      });
  };

  const handleUserStatus = (user, action) => {
    setIsEditModalOpen(false);
    action === "disable"
      ? handleDisableConfirmation(user, action)
      : handleEnableConfirmation(user);
  };

  const handleDeleteUser = (user) => {
    setIsEditModalOpen(false);
    handleDeleteConfirmation(user);
  };

  const handleEditModelClose = (user) => {
    setIsEditModalOpen(false);
    // fetchData(selectedRole)
  };

  const isEditUserDisable = useCallback(
    (userToEdit) => {
      if (
        !(
          loggedInUserRole === USER_ROLES.adminCorp ||
          loggedInUserRole === USER_ROLES.superAdminCorp
        )
      ) {
        return true;
      }

      /**Same user can not edit his profile*/
      if (userToEdit.PK === userData?.PK) return true;

      /**Admin can't edit Super Admin & Admins */
      if (
        loggedInUserRole === USER_ROLES.adminCorp &&
        (userToEdit.UserRole === USER_ROLES_STR.superAdminCorp ||
          userToEdit.UserRole === USER_ROLES_STR.adminCorp)
      ) {
        return true;
      }

      return false;
    },
    [userData?.PK, loggedInUserRole]
  );

  /**New Implementation of edit user modal starts end*/

  return (
    <div className="bodyInner userListWrapper">
      <div className="bodyContainer">
        {/* Header Section Starts */}
        <div className="controllesWrapper fixSubHeader">
          <div>
            {showUsers && (
              <span className="totalCount" id="user_count">
                {selectedRole !== "All" || searchString?.length ? (
                  <>
                    {t("userHeadingWithFilters", {
                      filteredCount: `${filteredUserCount}`,
                      totalCount: `${totalUserCount}`,
                    })}
                  </>
                ) : (
                  <>{t("userHeading", { count: `${totalUserCount}` })}</>
                )}
              </span>
            )}
          </div>
          <div className="d-flex align-items-center">
            <div className="searchInputWrapper" id="search">
              <input
                id="search_input"
                type="search"
                placeholder="Search Email Id/Name"
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
              />
              {searchTerm?.length ? (
                <span
                  className="close-icon"
                  onClick={resetSearch}
                  title={t("clear")}
                >
                  {Icons.closeIcon}
                </span>
              ) : (
                <span id="searchIcon" onClick={() => fetchData(selectedRole)}>
                  {Icons.searchIcon}
                </span>
              )}
              {/* <span id="searchIcon" onClick={() => fetchData(selectedRole)}>
                {Icons.searchIcon}
              </span> */}
            </div>
            <DropDown
              options={[
                { label: "All Roles", value: "All" },
                { label: "Super Admin", value: "Super Admin" },
                { label: "Admin", value: "Admin" },
                { label: "User", value: "User" },
                { label: "View Only User", value: "View Only User" },
              ]}
              wrapperClass="primary"
              autoid="roles_list"
              value={selectedRole}
              onSelection={(val) => {
                setSelectedRole(val);
                setPageCount(1);
                storeSessionData("", val,"",1);
              }}
              customId="userRoles"
            />

            <button
              type="button"
              className="roundBtn primary"
              id="add_user_button"
              onClick={() => handleAddUser()}
            >
              <span className="add-user">{Icons.addIcon}</span>
              <span id="add_user_text">Add User</span>
            </button>
          </div>
        </div>
        {/* Header Section Ends */}

        {/* Data Section Starts */}

        {showUsers && userDataList.length ? (
          <div className="gridViewWrapper">
            <div className="gridViewInner">
              <table className="table table-striped" id="user_list_table">
                <thead>
                  <tr key={"userTable"}>
                    <th id="disableColumn">&nbsp;</th>
                    {columList.map((item, index) => (
                      <th key={`${index + 1}`} className="deviceListView">
                        <div
                          className="sortIconWrapper d-flex justify-content-start"
                          id="listheader"
                          onClick={() => {
                            if (item.sort) {
                              handleSort(item.key);
                            }
                          }}
                        >
                          <span
                            className="clipText"
                            title={item.label}
                            id={item.key}
                          >
                            {item.label}
                          </span>
                          {item.sort && (
                            <div
                              className="sortIcons"
                              id={`sort${item.key}`}
                              title={sortLabel[item.val]}
                            >
                              <button
                                type="button"
                                id="sort_asc"
                                className={classNames({
                                  active: item.val === "asc",
                                  ascbutton: "ascbutton",
                                })}
                              >
                                {Icons.upArrowIcon}
                              </button>
                              <button
                                type="button"
                                id="sort_desc"
                                className={classNames({
                                  active: item.val === "desc",
                                })}
                              >
                                {Icons.downArrowIcon}
                              </button>
                            </div>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {userDataList.map((user) => (
                    <tr key={user.id} className="text-start">
                      <td className="disabled-icon" name="accountStatus">
                        {user.AccountStatus === "Disabled" ? (
                          <button className="disableButtonIcon">
                            {Icons.disableIcon}
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                      <td name="email">{user.Email}</td>
                      <td name="userName">{user.UserName}</td>
                      <td name="phoneNumber">{user.PhoneNumber}</td>
                      <td name="userRole">{user.UserRole}</td>
                      <td name="editUser">
                        <button
                          type="button"
                          className="roundBtn primary editUserBtn"
                          onClick={() => {
                            onEditUserclick(user);
                          }}
                          disabled={isEditUserDisable(user)}
                          name="editUserBtn"
                        >
                          <span className={`edit-user`} name="editUserIcon">
                            {Icons.editIcon}
                            <span id="editUserText">Edit User</span>
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="bodyFooter footerFixed">
                <Pagination
                  currentPage={pageCount - 1}
                  totalPages={pageTotalCount}
                  pageCallBack={handlePageChange}
                />
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {/* Data Section Ends */}

        {/* No Data Section Starts */}
        {!isLoading && showUsers && !userDataList.length && (
          <div className="d-flex align-items-center justify-content-center h-100 w-100">
            <EmptyScreen
              img={Icons.emptyScreenUsersIcon}
              title={t("empty_screen_title")}
              desc={t("empty_screen_desc")}
              titleName="noUserFound"
              descName="noUserFound"
            />
          </div>
        )}
        {/* No Data Section Ends */}
      </div>

      {/* Loader Section Starts */}
      {isLoading ? <LoadingSpinner /> : <></>}
      {/* Loader Section Ends */}

      {/* Modal Section Starts */}

      {/* Edit User Component*/}
      {isEditModalOpen && (
        <EditUser
          selectedUser={editingRow}
          handleDisableConfirmation={
            (selectedUser, action) => handleUserStatus(selectedUser, action) // Need to update the callback functions later
          }
          handleDeleteConfirmation={(selectedUser) =>
            handleDeleteUser(selectedUser)
          }
          handleEditUser={(currentUserRole, currentUserSites) =>
            handleEditUser(currentUserRole, currentUserSites)
          }
          allSitesList={userSiteLists}
          onClose={() => handleEditModelClose()}
        />
      )}

      {/* Updated Modal for Edit User success pop-up starts  */}
      {saveEditSuccessModal && (
        <ModalComponent
          idName="saveEditSuccessModal"
          isOpen={saveEditSuccessModal}
          onCloseModal={() => setSaveEditSuccessModal(false)}
          descriptionText={t("success_message")}
        ></ModalComponent>
      )}

      {/* Updated Modal for Edit User success pop-up ends  */}

      {/* Updated Modal for Edit User failure pop-up starts  */}
      {saveEditFailureModal && (
        <>
          <ModalComponent
            idName="failureModal"
            isOpen={saveEditFailureModal}
            onCloseModal={() => {
              setSaveEditFailureModal(false);
            }}
            descriptionText={t("failure_message")}
          ></ModalComponent>
        </>
      )}
      {/* Updated Modal for Edit User failure pop-up ends  */}

      {disableErrorModal && (
        <ModalComponent
          idName="disable_error_modal"
          isOpen={disableErrorModal}
          onCloseModal={() => setDisableErrorModal(false)}
          descriptionText={t("disable_error_message")}
        ></ModalComponent>
      )}

      {enableErrorModal && (
        <ModalComponent
          idName="enable_error_modal"
          isOpen={enableErrorModal}
          onCloseModal={() => setEnableErrorModal(false)}
          descriptionText={t("enable_error_message")}
        ></ModalComponent>
      )}

      {deleteErrorModal && (
        <ModalComponent
          idName="delete_error_modal"
          isOpen={deleteErrorModal}
          onCloseModal={() => setDeleteErrorModal(false)}
          descriptionText={t("delete_error_message")}
        ></ModalComponent>
      )}

      {deletedSuccessfully && (
        <ModalComponent
          idName="delete_success_modal"
          isOpen={deletedSuccessfully}
          onCloseModal={() => setDeletedSuccessfully(false)}
          descriptionText={t("delete_success_message")}
        ></ModalComponent>
      )}

      {/* Add User Modal */}
      {isModalTrue && (
        <div className="addUserContainer">
          <Modal
            idName="addUserModal"
            isOpen
            onCloseModal={() => handleModalClose()}
            isCloseButton
          >
            <span id="add_user">Add User</span>
            <div className="add-user-wrapper">
              <div className="upperSection">
                <div className="emailContainer">
                  <label id="email_label">Email ID</label>
                  <div className="emailChipContainer">
                    {emails && (
                      <>
                        {emails.map((email, index) => (
                          <div key={`${index + 1}`} className="chip">
                            <span className="chipEmails">{email}</span>

                            <button
                              className="emailChipButton"
                              onClick={() => removeEmail(index)}
                            >
                              {Icons.locationCLoseCircleIcon}
                            </button>
                          </div>
                        ))}
                      </>
                    )}
                  </div>

                  <div>
                    {!disableInput && (
                      <input
                        type="text"
                        id="email_input"
                        placeholder="  Upto 5 Email IDs, comma separated"
                        className={`emailInputBox ${
                          isEmailSubmit ? "active" : ""
                        }`}
                        value={emailInput}
                        onChange={handleInputChange}
                        onKeyPress={handleEmailInputKeyPress}
                        onBlur={handleEmailAddition}
                        disabled={disableInput}
                      />
                    )}
                    {error && <div className="error">{error}</div>}
                  </div>
                </div>

                <div className="userRoleContainer">
                  <label id="role_label">Role</label>
                  {userData ? (
                    <DropDown
                      options={
                        loggedInUserRole === USER_ROLES.adminCorp
                          ? rolesForAdmin
                          : rolesForSuperAdmin
                      }
                      wrapperClass="roleDropdown"
                      autoid="roles_list"
                      value={roleSelected}
                      onSelection={(val) => {
                        setRoleSelected(val);
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <hr />
              <div className="bottomSection">
                <div className="sitesContainer">
                  {Icons.sitesICon}
                  <span id="sites_count">Sites : {userSiteLists.length}</span>
                </div>

                {userData && userData.UserRole === "Admin" ? (
                  <div className="checkboxContainer">
                    {userSiteLists.map((user, index) => (
                      <label key={`${index + 1}`}>
                        <span id={`siteName_${index + 1}`}>
                          {user.SiteName}
                        </span>
                        <input
                          type="checkbox"
                          value={user.SiteId}
                          onChange={handleCheckboxChange}
                          disabled={user.HasAccess === "False" ? true : false}
                        />
                        <span
                          className="checkbox-icon-wrapper"
                          id={`checkbox-icon-wrapper-${index + 1}`}
                        >
                          <span
                            className="checkbox-icon"
                            id={`checkbox-icon-${index + 1}`}
                          >
                            {Icons.purpleTickCheckedBox}
                          </span>
                        </span>
                      </label>
                    ))}
                  </div>
                ) : (
                  <div className="checkboxContainer">
                    {roleSelected === "Super Admin" ? (
                      <>
                        {userSiteLists.map((user, index) => (
                          <label key={`${index + 1}`}>
                            <span id={`siteName_${index + 1}`}>
                              {user.SiteName}
                            </span>
                            <input
                              type="checkbox"
                              value={[]}
                              onChange={handleCheckboxChange}
                              checked
                              disabled
                            />
                            <span
                              className="checkbox-icon-wrapper"
                              id={`checkbox-icon-wrapper-${index + 1}`}
                            >
                              <span
                                className="checkbox-icon"
                                id={`checkbox-icon-${index + 1}`}
                              >
                                {Icons.purpleTickCheckedBox}
                              </span>
                            </span>
                          </label>
                        ))}
                      </>
                    ) : (
                      <>
                        {userSiteLists.map((user, index) => (
                          <label key={`${index + 1}`}>
                            <span id={`siteName_${index + 1}`}>
                              {user.SiteName}
                            </span>
                            <input
                              type="checkbox"
                              value={user.SiteId}
                              onChange={handleCheckboxChange}
                              checked={checkedList.includes(`${user.SiteId}`)}
                            />
                            <span
                              className="checkbox-icon-wrapper"
                              id={`checkbox-icon-wrapper-${index + 1}`}
                            >
                              <span
                                className="checkbox-icon"
                                id={`checkbox-icon-${index + 1}`}
                              >
                                {Icons.purpleTickCheckedBox}
                              </span>
                            </span>
                          </label>
                        ))}
                      </>
                    )}
                  </div>
                )}
                <div className="buttonContainer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    id="cancel"
                    onClick={() => {
                      setCancelModal(true);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className={`btn btn-primary ${
                      isButtonValid ? "active" : ""
                    }`}
                    id="invite"
                    onClick={() => {
                      setAcceptModal(true);
                      sendInvite();
                      setIsLoading(true);
                      setIsButtonValid(false);
                    }}
                    disabled={!isButtonValid}
                  >
                    {t("invite")}
                  </button>
                </div>

                {isLoading ? (
                  <LoadingSpinner />
                ) : (
                  <>
                    {inviteSuccess ? (
                      <>
                        <ModalComponent
                          idName="acceptModal"
                          isOpen={acceptModal}
                          onCloseModal={() => handleModalClose()}
                          descriptionText={t("email_invite_success_message")}
                        ></ModalComponent>
                      </>
                    ) : (
                      <>
                        <ModalComponent
                          idName="errorModal"
                          isOpen={acceptModal}
                          onCloseModal={() => handleFailureModalClose()}
                          descriptionText={errorMessage}
                        ></ModalComponent>
                      </>
                    )}
                  </>
                )}
                <ModalComponent
                  idName="addUserCancelmodal"
                  isOpen={cancelModal}
                  onCloseModal={() => setCancelModal(false)}
                  descriptionText={t("email_invite_cancel_message")}
                  needConfirmation={true}
                  onConfirm={() => {
                    handleModalClose();
                  }}
                ></ModalComponent>
              </div>
            </div>
          </Modal>
        </div>
      )}

      {/* Modal Section Ends */}
    </div>
  );
};
export default UserList;